"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Discussion = babelHelpers.interopRequireDefault(require("components/Discussion"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _tabbedContent = require("tabbed-content");

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var DiscussionTab = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(DiscussionTab, _Component);

  function DiscussionTab() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, DiscussionTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(DiscussionTab)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "discussionRoot", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "userId", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "trackData", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(DiscussionTab, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "objectBodyTab container"
      }, _react.default.createElement("div", {
        id: "discussionRoot"
      }, _react.default.createElement(_Discussion.default, {
        discussionRoot: this.discussionRoot,
        userId: this.userId,
        trackData: this.trackData,
        commentPosted: _tabbedContent.fixSoon
      })));
    }
  }], [{
    key: "value",
    value: function value(object, page, tab) {
      if (tab.visible()) {
        var id = tab.id,
            order = tab.order,
            title = tab.title;
        return {
          type: 'tab/Discussion',
          discussionRoot: object.discussionRoot,
          userId: _exports.default.Session.getLoggedInUserId(),
          trackData: this.getTrackData(object, page, tab),
          id: id,
          order: order,
          title: title
        };
      }
    }
  }, {
    key: "getTrackData",
    value: function getTrackData(object, page, tab) {
      return {
        catalogItem: object.id
      };
    }
  }]);
  return DiscussionTab;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "userId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = DiscussionTab;